import { VVGarageAddCustomerCtrl }  from './vv-garage.add-customer';
import { VVGarageStates }           from './vv-garage.states.ajs';
import { VVGarageService }          from './vv-garage.service';
import { VVGarageSettingsCtrl }     from './vv-garage.settings';

angular.module('workshop.vv-garage', [])
.config(VVGarageStates)
.controller('VVGarageAddCustomerCtrl', VVGarageAddCustomerCtrl)
.controller('VVGarageSettingsCtrl', VVGarageSettingsCtrl)
.factory('VVGarage', VVGarageService);
